import { createAction, props } from '@ngrx/store';
import * as appsActions from './apps';
import * as specialFeaturesActions from './special-features';
import * as rangeActions from './range';
import { IDashboardState } from '../states';

const actionPrefix = '[Dashboard]';

const loadDashboardData = createAction(`${actionPrefix} Load Dashboard Data`, props<{ shopId: number }>());

const loadDashboardDataSuccess = createAction(`${actionPrefix} Load Dashboard Data Success`, props<IDashboardState>());

const loadDashboardDataFailure = createAction(`${actionPrefix} Load Dashboard Data Failure`);

const toggleFieldsToActions = {
  ...appsActions.toggleFieldsToActions,
  ...specialFeaturesActions.toggleFieldsToActions,
};

function mapToggleFieldToAction(toggleField: string) {
  return toggleFieldsToActions[toggleField];
}

export {
  specialFeaturesActions,
  appsActions,
  rangeActions,
  loadDashboardData,
  loadDashboardDataSuccess,
  loadDashboardDataFailure,
  mapToggleFieldToAction,
};
